export default __webpack_public_path__ + "static/5-87cd7671dea4057c69de5679acd929e8.jpg";